import { createI18n } from 'vue-i18n';

// 引入业务自定义的语言包
const localCN = require('./locale/zh'); // 简体
const localUS = require('./locale/en'); // English

const messages = {
  zh_CN: { ...localCN },
  en_US: { ...localUS },
};

// localStorage获取当前语言类型(初次本地不存在'lang'字段存储，默认设置为'zh_CN')
const lang = localStorage.getItem('lang') || 'zh_CN';
console.log('初始语言类型', lang);

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: lang, // set locale
  messages: messages, // set locale messages
});

export default i18n;
